import { b2x } from '@b2x/react/src';

import { IconName, IconSize } from './Icon';

export type ButtonVariant =
  | b2x.CommonButtonVariant
  | 'primary'
  | 'secondary'
  | 'brand-primary'
  | 'brand-secondary'
  | 'gray-700'
  | 'gray-500'
  | 'gray-300'
  | 'gray-100'
  | 'outline-primary'
  | 'outline-secondary'
  | 'outline-brand-primary'
  | 'outline-brand-secondary'
  | 'outline-gray-700'
  | 'outline-gray-500'
  | 'outline-gray-300'
  | 'outline-gray-100';

export type ButtonProps = b2x.ButtonProps<ButtonVariant, IconName, IconSize>;

export const Button = (props: ButtonProps) => <b2x.Button<ButtonVariant, IconName, IconSize> {...props} />;
